import React, {useState, useEffect, useRef} from 'react';
import {Tooltip} from "primereact/tooltip";
import {useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {ConfirmDialog} from "primereact/confirmdialog";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import {Badge} from "primereact/badge";

const _FM_ReservationListComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const [reservation, setReservation] = useState([]);
  const [showDeleted, setShowDeleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hotelConnectRetryLoadingById, setHotelConnectRetryLoadingById] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('reservation_first')) || 0,
    rows: Number(localStorage.getItem('reservation_rows')) || rows,
    page: Number(localStorage.getItem('reservation_page')) || 0,
    sortField: localStorage.getItem('reservation_sortField') || 'reserved_from',
    sortOrder: Number(localStorage.getItem('reservation_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('reservation_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if(showDeleted === true) {
        query += '&search[deleted_at][operator]=is_not_null'
      } else {
        query += '&search[deleted_at][operator]=is_null'
      }
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setReservation(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', reservationSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', reservationSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                disabled={rowData.deleted_at_snapshot}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/reservation/read/' + rowData.id);
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                tooltip={t('edit')}
                disabled={rowData.deleted_at_snapshot || !!rowData.relocated_to}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/reservation/update/' + rowData.id);
                }}/>
        {rowData && rowData.deleted_at_snapshot ? (
          <Button icon="pi pi-undo" className="p-button-sm p-button-success"
                  tooltip={t('restore')}
                  tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    axios({
                      method: 'get',
                      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/" + rowData.id + "/restore",
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                        "Sys-name": Cookies.get("instanceId"),
                        "Preferred-locale": Cookies.get("language")
                      }
                    })
                      .then(response => {
                        window.App.toastShow('success', t('success_restore'),);
                        loadLazyData();
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}
          />
        ) : (
          <>
            <Button icon="pi pi-trash" className="p-button-sm  p-button-danger"
                    tooltip={t('delete')}
                    disabled={rowData?.status !== 'pending'}
                    tooltipOptions={{position: 'left'}}
                    onClick={() => {
                      window.App.setState({[`confirmDelete${rowData.id}`]: true})
                    }}
            />
            <ConfirmDialog group="declarative" visible={window.App.state[`confirmDelete${rowData.id}`]}
                           acceptLabel={t('yes')} rejectLabel={t('no')}
                           onHide={() => {
                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                           }}
                           message={t('confirm_delete')} header={t('confirm_delete')} icon="pi pi-exclamation-triangle"
                           accept={() => {
                             window.App.delete('reservation', rowData.id)
                               .then(response => {
                                 window.App.toastShow('success', t('success_delete'),);
                                 loadLazyData();
                               })
                               .catch(error => {
                                 window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                               })
                           }}
                           reject={() => {
                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                           }}/>
          </>
        )}
      </React.Fragment>
    );
  }

  const getHotelConnectFoglalasStatusMeta = (status) => {
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase().trim() : '';
    const neutralStyle = {backgroundColor: '#dddddd', color: '#5f656b'};
    if (normalizedStatus === 'success') {
      return {badgeClass: '', value: t('hotelconnect_status_success'), style: {backgroundColor: '#0abb87', color: '#ffffff'}};
    }
    if (normalizedStatus === 'failed') {
      return {badgeClass: '', value: t('hotelconnect_status_failed'), style: {backgroundColor: '#f7a2a2', color: '#5f656b'}};
    }
    if (normalizedStatus === 'skipped') {
      return {badgeClass: '', value: t('hotelconnect_status_skipped'), style: neutralStyle};
    }
    return {badgeClass: '', value: t('hotelconnect_status_not_started'), style: neutralStyle};
  };

  const getHotelConnectFoglalasFields = (rowData) => {
    return {
      status: rowData?.hotelConnectFoglalasStatus ?? rowData?.hotel_connect_foglalas_status ?? null,
      error: rowData?.hotelConnectFoglalasError ?? rowData?.hotel_connect_foglalas_error ?? null,
      syncedAt: rowData?.hotelConnectFoglalasSyncedAt ?? rowData?.hotel_connect_foglalas_synced_at ?? null,
    };
  };

  const retryHotelConnectFoglalasSync = (reservationId) => {
    if (!reservationId) {
      return;
    }
    setHotelConnectRetryLoadingById((prevState) => ({
      ...prevState,
      [reservationId]: true,
    }));
    axios({
      method: 'post',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/" + reservationId + "/hotelconnect-ntak-foglalas-sync",
      data: {},
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        window.App.toastShow('success', t('success'), response?.data?.message || t('hotelconnect_sync_started_message'));
        loadLazyData();
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      })
      .finally(() => {
        setHotelConnectRetryLoadingById((prevState) => ({
          ...prevState,
          [reservationId]: false,
        }));
      })
  };

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('reservation_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('reservation_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('reservation_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('reservation_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('reservation_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('reservation_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderReservationList, window.App.state.rerenderUnitList, window.App.state.rerenderBerthList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('reservation_list')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          {localStorage.getItem('reservation_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('reservation_filters')
                 localStorage.removeItem('reservation_sortField')
                 localStorage.removeItem('reservation_sortOrder')
                 localStorage.removeItem('reservation_rows')
                 localStorage.removeItem('reservation_page')
                 localStorage.removeItem('reservation_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          {showDeleted === false ? (
              <Button type="button" icon={"pi pi-eye"}
                      label={t('show_deleted_only')}
                      onClick={() => {
                        setShowDeleted(true)
                        setTimeout(() => {
                          window.App.setState({rerenderReservationList: Math.random()})
                        }, 500)
                      }}
                      className="p-button-success p-ml-2"/>
          ) : (
            <Button type="button" icon={"pi pi-eye-slash"}
                    label={t('hide_deleted_only')}
                    onClick={() => {
                      setShowDeleted(false)
                      setTimeout(() => {
                        window.App.setState({rerenderReservationList: Math.random()})
                      }, 500)
                    }}
                    className="p-button-danger p-ml-2"/>
          )}
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('reservation_filters')
                             localStorage.removeItem('reservation_sortField')
                             localStorage.removeItem('reservation_sortOrder')
                             localStorage.removeItem('reservation_rows')
                             localStorage.removeItem('reservation_page')
                             localStorage.removeItem('reservation_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
          <Button type="button" label={t('new_reservation')} icon={"pi pi-plus"}
                  onClick={() => {
                    navigate('/reservation/create');
                  }}
                  className="p-button-success p-ml-2"/>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"reservation"}/> */}
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={reservation} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if(!rowData.data.deleted_at_snapshot)
          navigate('/reservation/read/' + rowData.data.id);
        }}
      >
        <Column className={"p-d-relative"} style={{position: 'relative', width: '10px', maxWidth: '10px'}}
                body={(rowData) => {
                  return (
                    <>
                          <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            height: '100%',
                            borderLeft: '10px solid #' + window.App.generateHexFromNumber(rowData.reservation_group.id),
                          }}></span>
                    </>
                  )
                }}/>
        <Column className={"p-d-relative"} style={{position: 'relative', width: '1px', maxWidth: '1px'}}
                body={(rowData) => {
                  if (rowData.errors && rowData.errors[0]) {
                    return (
                      <>
                          <span className={"error-reservation"} style={{
                            position: 'absolute',
                            left: 'right',
                            top: '0',
                            height: '100%',
                          }}></span>
                      </>
                    )
                  }
                }}/>
        {/**/}
        <Column field="association_code" sortable header={t('id')}
                className={"p-text-nowrap"}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                sortField={"id"}
                filterField={"public_id"}
                body={(rowData) => (
                  <>
                    <span className={"tt-association-code-info-" + rowData.id + " p-mr-2"}
                          data-pr-tooltip={rowData?.association_code}>
                      <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                    </span>
                    <Tooltip target={".tt-association-code-info-" + rowData.id}/>
                    <span
                      className={"p-badge"}
                      style={{
                        minWidth: '110px',
                        fontSize: '1rem',
                        backgroundColor: rowData?.status
                          ? rowData?.status?.toLowerCase() === 'pending'
                            ? '#dddddd'
                            : rowData?.status?.toLowerCase() === 'confirmed'
                              ? '#f1eea5'
                              : rowData?.status?.toLowerCase() === 'cancelled'
                                ? '#f7a2a2'
                                : rowData?.status?.toLowerCase() === 'checked_in'
                                  ? '#3ec0e9'
                                  : rowData?.status?.toLowerCase() === 'checked_out'
                                    ? '#0abb87'
                                    : rowData?.status?.toLowerCase() === 'relocated'
                                      ? '#fbc02d'
                                    : rowData?.status?.toLowerCase() === 'no_show'
                                      ? '#8a2be2'
                                      : '#ccc'
                          : undefined,
                        color: rowData?.status
                          ? rowData?.status?.toLowerCase() === 'pending'
                            || rowData?.status?.toLowerCase() === 'confirmed'
                            ? '#5f656b'
                            : rowData?.status?.toLowerCase() === 'cancelled'
                              ? '#5f656b'
                            : rowData?.status?.toLowerCase() === 'relocated'
                              ? '#212529'
                            : rowData?.status?.toLowerCase() === 'no_show'
                              ? '#fff'
                              : undefined
                          : undefined
                      }}
                    >
                      {rowData?.association_code?.split(' | ').pop()?.trim()}
                    </span>
                    {rowData.relocated_to &&
                      <div>
                        <span
                          className={"tt-relocated-to-list-info-" + rowData.id + " p-mr-2"}
                          data-pr-tooltip={t('reservation_number') + ': ' + (rowData?.relocated_to?.public_id || '-') + ' (#' + (rowData?.relocated_to?.id || '-') + ')'}>
                          <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                        </span>
                        <Tooltip target={".tt-relocated-to-list-info-" + rowData.id}>
                          {t('reservation_number')}: {rowData?.relocated_to?.public_id || '-'} (#{rowData?.relocated_to?.id || '-'})
                        </Tooltip>
                        <span className={"p-badge p-badge-warning"} style={{minWidth: '110px'}}>
                          {t('relocated_to')} <i className="pi pi-sign-in" style={{fontSize: "0.6rem"}}></i>
                        </span>
                      </div>
                    }
                    {rowData.relocated_from &&
                      <div>
                        <span
                          className={"tt-relocated-from-list-info-" + rowData.id + " p-mr-2"}
                          data-pr-tooltip={t('reservation_number') + ': ' + (rowData?.relocated_from?.public_id || '-') + ' (#' + (rowData?.relocated_from?.id || '-') + ')'}>
                          <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                        </span>
                        <Tooltip target={".tt-relocated-from-list-info-" + rowData.id}>
                          {t('reservation_number')}: {rowData?.relocated_from?.public_id || '-'} (#{rowData?.relocated_from?.id || '-'})
                        </Tooltip>
                        <span className={"p-badge p-badge-warning"} style={{minWidth: '110px'}}>
                          {t('relocated_from')} <i className="pi pi-sign-out" style={{fontSize: "0.6rem"}}></i>
                        </span>
                      </div>
                    }
                  </>
                )}
        ></Column>
        <Column field="reserved_from" sortable header={t('reserved_from')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.reserved_from !== null) {
                    return (
                      <span>{moment.utc(rowData.reserved_from).local().format(t('YYYY-MM-DD HH:mm'))}</span>
                    )
                  }
                }}></Column>
        <Column field="reserved_to" sortable header={t('reserved_to')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.reserved_to !== null) {
                    return (
                      <span>
                {moment.utc(rowData.reserved_to).local().format(t('YYYY-MM-DD HH:mm'))}
              </span>
                    )
                  }
                }}></Column>
        <Column field="accommodation.name" header={t('accommodation')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                filterField={"accommodation.name"}
                body={(rowData) => <><span className={"p-text-nowrap"}>{rowData?.accommodation?.name}<span className={"tt-auto-invoice p-ml-2"} data-pr-tooltip={rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"auto-invoice-icon"} style={{ color: rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd', position: 'relative', bottom: '-3px' }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8" /><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1" /><path d="M9 7h6" /><path d="M9 11h4" /><path d="M18 14a3 3 0 1 0 3 3" /><path d="M21 20v-3h-3" /></svg></span></span><Tooltip target=".tt-auto-invoice"/></>}
        ></Column>
        <Column header={t('residential_unit')} className={"p-text-nowrap"} body={(rowData) => {
          return (
            <>
              {rowData.berth === null && rowData.residential_unit &&
                <>
                  <i className={"pi pi-home p-ml-0 p-mr-2"}
                     style={{color: "#" + window.App.generateHexFromNumber(rowData?.reservation_group?.id)}}></i>
                  {rowData.residential_unit.name}
                  {/*{rowData?.residential_unit?.is_ready === true ? (*/}
                  {/*  <Badge severity="success" style={{*/}
                  {/*    height: '8px',*/}
                  {/*    width: '8px',*/}
                  {/*    minWidth: '8px',*/}
                  {/*    position: 'relative',*/}
                  {/*    top: '-5px',*/}
                  {/*    left: '5px'*/}
                  {/*  }}></Badge>*/}
                  {/*) : (*/}
                  {/*  <Badge severity="danger" style={{*/}
                  {/*    height: '8px',*/}
                  {/*    width: '8px',*/}
                  {/*    minWidth: '8px',*/}
                  {/*    position: 'relative',*/}
                  {/*    top: '-5px',*/}
                  {/*    left: '5px'*/}
                  {/*  }}></Badge>*/}
                  {/*)}*/}
                </>
              }
              {rowData.berth?.residential_unit &&
                <>
                  <i className={"pi pi-home p-ml-0 p-mr-2"}
                     style={{color: "#" + window.App.generateHexFromNumber(rowData?.reservation_group?.id)}}></i>
                  {rowData.berth.residential_unit.name}
                  {/*{rowData?.berth?.residential_unit?.is_ready === true ? (*/}
                  {/*  <Badge severity="success" style={{*/}
                  {/*    height: '8px',*/}
                  {/*    width: '8px',*/}
                  {/*    minWidth: '8px',*/}
                  {/*    position: 'relative',*/}
                  {/*    top: '-5px',*/}
                  {/*    left: '5px'*/}
                  {/*  }}></Badge>*/}
                  {/*) : (*/}
                  {/*  <Badge severity="danger" style={{*/}
                  {/*    height: '8px',*/}
                  {/*    width: '8px',*/}
                  {/*    minWidth: '8px',*/}
                  {/*    position: 'relative',*/}
                  {/*    top: '-5px',*/}
                  {/*    left: '5px'*/}
                  {/*  }}></Badge>*/}
                  {/*)}*/}
                </>
              }
              {!rowData.residential_unit && !rowData?.berth?.residential_unit &&
                <>
                  <span className={"p-badge danger-unit-not-found"} style={{backgroundColor: '#f7a2a2', color: '#5f656b', fontWeight: 400, display: 'block', width: '100%'}}>
                    {t('reservation_unit_not_found')}
                  </span>
                </>
              }
              {rowData.berth &&
                <span className={"p-d-block"}>
                  <i className={"pi pi-inbox p-mr-2"}
                     style={{fontSize:"0.9rem", color: "#" + window.App.generateHexFromNumber(rowData?.reservation_group?.id)}}></i>
                  {rowData.berth.name}
                </span>
              }

            </>
          )
        }}>
        </Column>
        <Column field="status" header={t('status')} sortable
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                body={(rowData) => {
                  return (
                    <>
                      {rowData.status ? (
                        rowData.status.toLowerCase() === 'pending' ? (
                          <Badge value={t('pending')} severity="info"
                                 style={{backgroundColor: '#dddddd', color: '#5f656b', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'confirmed' ? (
                          <Badge value={t('reserved')} severity="success"
                                 style={{backgroundColor: '#f1eea5', color: '#5f656b', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'cancelled' ? (
                          <Badge value={t('cancelled')} severity="danger"
                                 style={{backgroundColor: '#f7a2a2', color: '#5f656b', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'checked_in' ? (
                          <Badge value={t('checked_in')} severity="success"
                                 style={{backgroundColor: '#3ec0e9', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'checked_out' ? (
                          <Badge value={t('checked_out')} severity="success"
                                 style={{backgroundColor: '#0abb87', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'relocated' ? (
                          <Badge value={t('relocated_checked_out')} severity="warning"
                                 style={{backgroundColor: '#fbc02d', color: '#212529', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'no_show' ? (
                          <Badge value={t('no_show')} severity="warning"
                                 style={{backgroundColor: '#8a2be2', color: '#fff', width: '100%'}}></Badge>
                        ) : (
                          <Badge value={t('unknown_status')} severity="warning"
                                 style={{backgroundColor: '#ccc', width: '100%'}}></Badge>
                        )
                      ) : (
                        <Badge value={t('no_status')} severity="warning"
                               style={{backgroundColor: '#ccc', width: '100%'}}></Badge>
                      )}
                    </>
                  )
                }}
        ></Column>
        <Column field="hotelConnectFoglalasStatus"
                header={t('reservation_sync')}
                className={"p-text-center p-text-nowrap"}
                body={(rowData) => {
                  const hotelConnectFoglalas = getHotelConnectFoglalasFields(rowData);
                  const statusMeta = getHotelConnectFoglalasStatusMeta(hotelConnectFoglalas.status);
                  const normalizedHotelConnectStatus = typeof hotelConnectFoglalas.status === 'string'
                    ? hotelConnectFoglalas.status.toLowerCase().trim()
                    : '';
                  const isFailed = normalizedHotelConnectStatus === 'failed';
                  return (
                    <div className={"p-d-flex p-ai-center p-jc-center"}>
                      <span
                        className={`p-badge p-d-block w-100 ${statusMeta.badgeClass || ''} tt-hotelconnect-retry-list-${rowData?.id}`}
                        role={isFailed ? 'button' : undefined}
                        tabIndex={isFailed ? (hotelConnectRetryLoadingById[rowData?.id] ? -1 : 0) : undefined}
                        data-pr-tooltip={isFailed ? t('hotelconnect_sync_retry_label') : undefined}
                        style={{
                          ...statusMeta.style,
                          fontWeight: 400,
                          alignItems: 'center',
                          gap: '0.35rem',
                          cursor: isFailed && !hotelConnectRetryLoadingById[rowData?.id] ? 'pointer' : 'default'
                        }}
                        onClick={() => {
                          if (!isFailed || hotelConnectRetryLoadingById[rowData?.id]) {
                            return;
                          }
                          retryHotelConnectFoglalasSync(rowData?.id);
                        }}
                        onKeyDown={(event) => {
                          if (!isFailed || hotelConnectRetryLoadingById[rowData?.id]) {
                            return;
                          }
                          if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            retryHotelConnectFoglalasSync(rowData?.id);
                          }
                        }}
                      >
                        <span>{statusMeta.value}</span>
                        {isFailed &&
                          <>
                            <i
                              className={`p-ml-1 pi ${hotelConnectRetryLoadingById[rowData?.id] ? 'pi-spin pi-spinner' : 'pi-refresh'}`}
                              style={{color: 'inherit', fontSize: '0.8rem'}}
                            ></i>
                            <Tooltip target={`.tt-hotelconnect-retry-list-${rowData?.id}`}/>
                          </>
                        }
                      </span>
                    </div>
                  )
                }}>
        </Column>
        <Column field="source" header={t('source')} sortable
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                className={"p-text-center"}
                body={(rowData) => {
                  if(rowData.source) {
                    return(
                      <>
                        {t(rowData.source.toLowerCase())}
                      </>
                    )
                  }
                }}
        ></Column>
        {/*<Column field="internal_creation" header={t('internal_creation')} sortable className={"p-text-left"}*/}
        {/*        body={(rowData) => {*/}
        {/*          return (*/}
        {/*            <>*/}
        {/*              {rowData.internal_creation === true ? (*/}
        {/*                <i className={"pi pi-check text-success"}></i>*/}
        {/*              ) : (*/}
        {/*                <i className={"pi pi-times text-danger"}></i>*/}
        {/*              )}*/}
        {/*            </>*/}
        {/*          )*/}
        {/*        }}*/}
        {/*></Column>*/}
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                filter
                filterField={"created_at"}
                sortField={"created_at"}
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.updated_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_ReservationListComponent);
